import {createContext} from 'react'

const Application=createContext()

export default Application